import { render, staticRenderFns } from "./EmpilhadeiraCardList.vue?vue&type=template&id=062ea4b2&"
import script from "./EmpilhadeiraCardList.vue?vue&type=script&lang=js&"
export * from "./EmpilhadeiraCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports